import classNames from 'classnames';

/**
 * A progress bar for indicating the current step in a multi-step process.
 * It is used in the ProductSelectSection component.
 */
export default function ProgressBar({
  currentStep,
  stepsCount,
}: ProgressBarProps) {
  return (
    <div className="flex items-center gap-x-0.5">
      {Array.from({length: stepsCount}, (_, i) => {
        const step = i + 1;
        return (
          <>
            <span
              className={classNames(
                'm-0.5 flex h-4.5 w-4.5 shrink-0 items-center justify-center rounded-full  text-xs font-medium text-bright-white fast-transition',
                {
                  'bg-dark-blue-gray': step === currentStep,
                  'bg-logo-lime': step < currentStep,
                  'bg-neutral-gray': step > currentStep,
                }
              )}
            >
              {step}
            </span>
            {step < stepsCount && (
              <hr
                className={classNames(
                  'h-0.75 w-12 transition-all duration-150 ease-out',
                  {
                    'bg-logo-lime': step < currentStep,
                    'bg-neutral-gray': step >= currentStep,
                  }
                )}
              />
            )}
          </>
        );
      })}
    </div>
  );
}

type ProgressBarProps = {
  currentStep: number;
  stepsCount: number;
};
